<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="850" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} configuración
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
            <!-- Datos de la línea -->
            <div class="section-label primary--text">Datos de la línea</div>
            <v-divider class="mb-3"></v-divider>

            <v-row>
              <!-- Nombre -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    label="Nombre"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Número -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="número de teléfono" rules="required|numeric" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.number"
                    :error-messages="errors"
                    label="Número de teléfono"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- URL -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="URL" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.url"
                    :error-messages="errors"
                    label="URL"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Security Key -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="secure key" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.secureKey"
                    :error-messages="errors"
                    label="Secure Key"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Web Key -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="web key" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.webKey"
                    :error-messages="errors"
                    label="Web Key"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Cola por defecto -->
              <v-col cols="12" sm="6" class="pb-0">
                <ValidationProvider name="Cola" rules="required" v-slot="{ errors }">
                  <v-select
                    v-model="payload.queue_id"
                    :items="queueList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Cola por defecto"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>

            <!-- Mensajes automáticos -->
            <div class="section-label primary--text mt-6">Mensajes automáticos</div>
            <v-divider class="mb-3"></v-divider>

            <v-row>
              <!-- Enviar mensaje inicial -->
              <v-col cols="12" class="pb-0 mt-2">
                <ValidationProvider>
                  <v-switch
                    v-model="payload.send_message"
                    label="Enviar mensaje inicial"
                    color="success"
                    inset
                  ></v-switch>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje inicial -->
              <v-col cols="12" class="pb-0" v-if="payload.send_message">
                <ValidationProvider name="Mensaje" rules="required" v-slot="{ errors }">
                  <v-textarea
                    filled
                    rounded
                    class="rounded-small"
                    auto-grow
                    rows="3"
                    name="initial_message"
                    label="Mensaje inicial"
                    v-model="payload.initial_message"
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Closing Message -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="Mensaje de cierre" rules="required" v-slot="{ errors }">
                  <v-textarea
                    v-model="payload.closing_message"
                    :error-messages="errors"
                    label="Mensaje de cierre"
                    rounded
                    class="rounded-small"
                    filled
                    auto-grow
                    rows="3"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Warning Message -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="Mensaje de alerta" rules="required" v-slot="{ errors }">
                  <v-textarea
                    v-model="payload.warning_message"
                    :error-messages="errors"
                    label="Mensaje de alerta"
                    rounded
                    class="rounded-small"
                    filled
                    auto-grow
                    rows="3"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Outime Message -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="Mensaje fuera de horario" rules="required" v-slot="{ errors }">
                  <v-textarea
                    v-model="payload.out_of_hours_message"
                    :error-messages="errors"
                    label="Mensaje fuera de horario"
                    rounded
                    class="rounded-small"
                    filled
                    auto-grow
                    rows="3"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>
            </v-row>

            <!-- Redirección por texto clave -->
            <div class="section-label primary--text mt-6">Redirección por texto clave</div>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <!-- Activar redirección -->
              <v-col cols="12" class="pb-0 mt-2">
                <ValidationProvider>
                  <v-switch
                    v-model="payload.keyword_redirection"
                    label="Activar redirección por texto clave"
                    color="success"
                    inset
                  ></v-switch>
                </ValidationProvider>
              </v-col>

              <!-- Textos clave de la línea -->
              <v-col cols="12" class="pt-0">
                <keyword-redirection-section
                  :enabled="!!payload.keyword_redirection"
                  :whatsappId="payload.id || null"
                  :whatsappLabel="whatsappLabel"
                ></keyword-redirection-section>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>

        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text> Cerrar </v-btn>
          <v-spacer></v-spacer>

          <v-btn @click="handleSubmit(submitForm)" :disabled="isLoading" class="px-8" color="success" rounded large>
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import { DIALOG_MAX_HEIGHT } from "@/utils";
import keywordRedirectionSection from "./keywordRedirection/section.vue";

export default {
  components: {
    vuescroll,
    keywordRedirectionSection,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      isLoading: false,
      clientList: [],
      queueList: [],
      payload: {
        name: "",
        url: "",
        number: "",
        secureKey: "",
        webKey: "",
        queue_id: null,
        initial_message: "",
        closing_message: "",
        warning_message: "",
        out_of_hours_message: "",
        keyword_redirection: false,
        // bill_type: "",
        // client_id: null,
      },
    };
  },

  created() {
    this.getSelectsInfo();
    this.payload = { ...this.dataToEdit };
    this.payload.keyword_redirection = !!this.payload.keyword_redirection;
  },

  computed: {
    whatsappLabel() {
      return [this.payload.name, this.payload.number].filter(Boolean).join(" - ");
    },
  },

  methods: {
    resetform() {
      this.payload.name = "";
      this.payload.url = "";
      this.payload.number = "";
      this.payload.secureKey = "";
      this.payload.webKey = "";
      this.payload.closing_message = "";
      this.payload.warning_message = "";
      this.payload.out_of_hours_message = "";
      this.payload.keyword_redirection = false;
      // this.payload.client_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      let endpoints = ["/clients/show", "/clients/queues"];

      await axios
        .all(endpoints.map((endpoint) => PbxHttpClient.get(endpoint)))
        .then((res) => {
          this.clientList = res[0].data;
          this.queueList = res[1].data.data;
        })
        .catch(() => {
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      // const { id, ...payload } = this.payload;

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/admin/config/whatsapps/${id}`, payload)
          : await PbxHttpClient.post("/admin/config/whatsapps", payload);
        this.closeDialog(data);

        this.$snotify.success(`Configuración ${this.isEditMode ? "actualizada" : "creada"} con éxito.`, "¡Hecho!");
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.section-label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
</style>
